export default "__VITE_ASSET__mzg7Zyr6__"